import { SvgIcon } from '@mui/material';

function BellRingIcon({ color, width = '24', height = '24' }) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 24 24" fill="none">
      <g id="ph:bell-ringing">
        <path
          id="Vector"
          d={`M21 6.66552C20.8235 6.75695 20.6178 6.77453 20.4283 6.71441C20.2388 
        6.65428 20.0809 6.52138 19.9894 6.3449C19.2735 4.93067 18.1899 3.73537 16.8525 2.88458C16.7692 
        2.83202 16.697 2.76354 16.6401 2.68308C16.5832 2.60261 16.5427 2.51173 16.521 2.41563C16.4992 
        2.31952 16.4966 2.22006 16.5133 2.12294C16.5299 2.02582 16.5656 1.93293 16.6181 1.84958C16.6707 
        1.76624 16.7392 1.69406 16.8196 1.63717C16.9001 1.58029 16.991 1.53981 17.0871 1.51804C17.1832 
        1.49628 17.2827 1.49366 17.3798 1.51033C17.4769 1.527 17.5698 1.56264 17.6531 1.61521C19.2118 
        2.61321 20.4775 4.0073 21.3206 5.6549C21.4121 5.83145 21.4296 6.03707 21.3695 6.22658C21.3094 
        6.41609 21.1765 6.57397 21 6.66552ZM3.34783 6.7499C3.48523 6.74984 3.61998 6.71204 3.73736 
        6.64062C3.85474 6.56919 3.95025 6.4669 4.01346 6.3449C4.72933 4.93067 5.81291 3.73537 7.15033 
        2.88458C7.23368 2.83202 7.30586 2.76354 7.36274 2.68308C7.41963 2.60261 7.46011 2.51173 7.48187 
        2.41563C7.50364 2.31952 7.50626 2.22006 7.48959 2.12294C7.47291 2.02582 7.43727 1.93293 7.38471 
        1.84958C7.33214 1.76624 7.26366 1.69406 7.1832 1.63717C7.10274 1.58029 7.01186 1.53981 6.91575 
        1.51804C6.81964 1.49628 6.72018 1.49366 6.62306 1.51033C6.52594 1.527 6.43305 1.56264 6.34971 
        1.61521C4.79102 2.61321 3.52537 4.0073 2.68221 5.6549C2.62299 5.7692 2.59419 5.89681 2.59858 
        6.02547C2.60297 6.15412 2.6404 6.27948 2.70726 6.38947C2.77413 6.49947 2.86818 6.59041 2.98037 
        6.65353C3.09256 6.71666 3.2191 6.74984 3.34783 6.7499ZM20.7947 16.4943C20.9276 16.7221 20.998 
        16.981 20.9989 17.2447C20.9998 17.5085 20.9312 17.7678 20.7999 17.9966C20.6686 18.2254 20.4793 
        18.4155 20.251 18.5477C20.0228 18.68 19.7638 18.7497 19.5 18.7499H15.675C15.5029 19.5976 15.043 
        20.3598 14.3732 20.9072C13.7035 21.4546 12.865 21.7537 12 21.7537C11.135 21.7537 10.2966 21.4546 
        9.62682 20.9072C8.95707 20.3598 8.49715 19.5976 8.32502 18.7499H4.50002C4.23641 18.7494 3.9776 
        18.6794 3.74965 18.547C3.5217 18.4146 3.33266 18.2245 3.20158 17.9958C3.0705 17.7671 3.002 17.5079 
        3.00299 17.2443C3.00398 16.9807 3.07441 16.722 3.20721 16.4943C4.05189 15.0365 4.50002 12.9636 
        4.50002 10.4999C4.50002 8.51077 5.29019 6.60312 6.69672 5.1966C8.10324 3.79007 10.0109 2.9999 
        12 2.9999C13.9891 2.9999 15.8968 3.79007 17.3033 5.1966C18.7098 6.60312 19.5 8.51077 
        19.5 10.4999C19.5 12.9627 19.9481 15.0355 20.7947 16.4943ZM14.1206 18.7499H9.87939C10.0348 
        19.1881 10.3221 19.5674 10.7018 19.8357C11.0816 20.1039 11.5351 20.2479 12 20.2479C12.465 
        20.2479 12.9185 20.1039 13.2982 19.8357C13.6779 19.5674 13.9653 19.1881 14.1206 18.7499ZM19.5 
        17.2499C18.5025 15.5371 18 13.2665 18 10.4999C18 8.9086 17.3679 7.38247 16.2427 6.25726C15.1174 
        5.13204 13.5913 4.4999 12 4.4999C10.4087 4.4999 8.8826 5.13204 7.75738 6.25726C6.63216 7.38247 
        6.00002 8.9086 6.00002 10.4999C6.00002 13.2674 5.49564 15.538 4.50002 17.2499H19.5Z`}
          fill={color}
        />
      </g>
    </SvgIcon>
  );
}

export default BellRingIcon;
